import { render, staticRenderFns } from "./card-5.vue?vue&type=template&id=17b8b740&scoped=true&"
import script from "./card-5.vue?vue&type=script&lang=js&"
export * from "./card-5.vue?vue&type=script&lang=js&"
import style0 from "./card-5.vue?vue&type=style&index=0&id=17b8b740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8b740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardActions,VCardText,VListItem,VListItemContent})
